import script from "./PlanSelector2.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanSelector2.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__